import CourseEdit from "@/controllers/course/course-edit";

export default {
    extends: CourseEdit,
}
